<div [ngClass]="open ? '' : 'hidden'" class="fixed z-999 overflow-hidden inset-0 m-auto flex items-center justify-center w-full h-[100vh]" style="background-color: #000000a1;" (click)="onBackdropClick($event)">
  <div class="relative h-auto max-w-[100%] w-fit min-w-[50%] p-4">
    <div class="relative bg-white dark:bg-neutral-900 rounded-lg shadow dark:shadow-neutral-900 w-full">
      @if (title) {
        <div class="flex justify-between items-center px-6 py-4 border-b border-gray-100 dark:border-gray-700">
          <h5 class="text-xl font-semibold">{{ title | translate }}</h5>
          <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ms-auto inline-flex items-center dark:hover:bg-neutral-900 dark:hover:text-white" (click)="closeDialog()">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
          </button>
        </div>
      }
      <div class="p-6">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
